<script setup>
import { CountUp } from 'countup.js'
import {v4 as uuidv4} from "uuid"
import {computed, onMounted, reactive, ref, watch} from "vue"

const props = defineProps({
    count: {
        type: Number,
        required: true,
    },
    duration: {
        type: Number,
        default: 0.75,
    },
    decimalPlaces: {
        type: Number,
        default: 0
    },
    prefix: {
        type: String,
        default: ""
    },
    suffix: {
        type: String,
        default: ""
    },
})

const state = reactive({
    previousValue: 0,
})

watch(
    () => props.count,
    (count) => state.previousValue = count,
    {immediate: true}
)

const counter = ref(null)
const id = computed(() => `input-${uuidv4()}`)
const number = computed(() => props.count)

const run = (n) => {
    let animation = new CountUp(
        counter.value,
        Number(n) || 0,
        {
            decimalPlaces: props.decimalPlaces,
            duration: props.duration,
            prefix: props.prefix,
            suffix: props.suffix,
        })
    animation.start()
}

watch(
    () => number,
    (number) => run(number.value),
    {deep: true}
)

onMounted(() => run(number.value))

</script>

<template>
    <div class="text-center" style="display: inline">
        <slot />
        <span :id="id" ref="counter"></span>
    </div>
</template>
